import axios from 'axios';
import { toast } from 'react-toastify';
const API_BASE_URL = 'https://api.printnode.com';
const API_KEY = process.env.PRINT_NODE_API_KEY;
export const createPrintJob = async (printJob) => {
    const auth = btoa(`${API_KEY}:`);
    try {
        const response = await axios.post(`${API_BASE_URL}/printjobs`, printJob, {
            headers: {
                Authorization: `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        });
        toast.success('Afdrukker Succesvol');
        return response.data;
    }
    catch (error) {
        console.error('Print job creation failed:', error);
        toast.error('Afdrukker Mislukt');
    }
};
